var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var FORM_ERROR_TAG = '_formError';
export var createFormError = function (msg) { return Object.assign(new Error(msg), { _tag: FORM_ERROR_TAG }); };
export var isFormError = function (e) { return e._tag === FORM_ERROR_TAG; };
export var genericErrorMessage = 'Something went wrong. Please try again later';
var DISPLAYED_ERROR = Symbol();
var DisplayedError = /** @class */ (function (_super) {
    __extends(DisplayedError, _super);
    function DisplayedError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // @ts-ignore: virtual field used for type assertion
        _this._TAG = DISPLAYED_ERROR;
        return _this;
    }
    return DisplayedError;
}(Error));
export { DisplayedError };
export var isDisplayedError = function (err) { return '_TAG' in err && err._TAG === DISPLAYED_ERROR; };
export var getDisplayedError = function (err) { return (isDisplayedError(err) ? err.message : genericErrorMessage); };
//# sourceMappingURL=error.utils.js.map